import { createAction } from 'redux-actions';
export const saveEditorDraft = createAction('DA_EDITOR.SAVE_EDITOR_DRAFT', (editorId, editorState)=>({
        editorId,
        editorState
    }));
export const removeEditorDraft = createAction('DA_EDITOR.REMOVE_EDITOR_DRAFT', (editorId)=>({
        editorId
    }));

//# sourceMappingURL=actions.js.map